//
// The company accepting the invite: the one the inviter picked, which the invitee
// can only confirm or refuse, or one the invitee finds in the registry. Nothing
// is recorded here; the logo page confirms it (/invite/confirmGovId).
//
import {
  useCallback,
  useEffect,
} from 'react';

import {
  Column,
  CompanyGovSearch,
  CompanyGovSummary,
  useWizardContext,
} from '../../../components';
import {
  useAuth,
  useTownAssets,
} from '../../../stores';
import { config } from '../../../utils';

import InviteAckRefusal from './InviteAckRefusal';

const pageStateValidator = (state) => ({
  valid: {},
  errors: {},
  pageValid: Boolean(state.cstmrGovId),
});

function InviteAckCompanyPage() {
  const { assets } = useTownAssets();
  const { translate } = assets;
  const { auth } = useAuth();
  const { superagentPostAsync } = auth;
  const {
    setPageInfo,
    setPageState,
    setMustConfirmClose,
    state,
  } = useWizardContext();

  const prtnrInvtInfo = state.invite?.prtnrInvtInfo;
  const target = prtnrInvtInfo?.target;
  const inviter = prtnrInvtInfo?.source?.cstmrLbl;

  useEffect(
    () => {
      setPageInfo({
        nextPage: 'logo',
        pageStateValidator,
      });
    },
    [setPageInfo],
  );

  const search = useCallback(
    async (searchReq) => {
      const res = await superagentPostAsync(
        config.town.back.urlPrefix + config.town.back.invite.search,
        ['Content-Type', 'application/json'],
        {
          piid: state.piid,
          ...searchReq,
        },
      );

      if (res?.status !== 200) throw new Error(`invite search status=${res?.status}`);

      return res.body.rslt.data;
    },
    [superagentPostAsync, state.piid],
  );

  const onPick = useCallback(
    (company) => {
      setMustConfirmClose(true);
      setPageState({
        company,
        cstmrGovId: company.cstmrGovId,
        confirmRefusalKey: undefined,
      });
    },
    [setPageState, setMustConfirmClose],
  );

  return (
    <Column crossStretch gap={4} className="flex-1 min-h-0 w-full overflow-y-auto p-2">
      {(target?.govIdLocked)
        ? (
            <>
              <span>{translate('inviteGovIdLockedByInviter', 'statements', { inviter })}</span>
              <CompanyGovSummary
                company={{
                  cstmrGovLbl: target.govLbl ?? target.cstmrLbl,
                  cstmrRegisteredAddress: target.cstmrRegisteredAddress,
                }}
              />
            </>
          )
        : (
            <>
              <span>{translate('inviteIdentifyYourCompany', 'statements', { inviter })}</span>
              <CompanyGovSearch
                search={search}
                picked={state.company}
                onPick={onPick}
              />
            </>
          )}

      <InviteAckRefusal
        piid={state.piid}
        inviter={inviter}
        onRefused={state.onRefused}
      />
    </Column>
  );
}

export default InviteAckCompanyPage;
